import React from 'react';
import {createMarkup} from '../../lib/helpers';
import useStore from '../../hooks/useStore';
import {OutroWrapper} from './Outro.styles';
import {Link} from 'react-router-dom';

const content = {
  en: {
    title: "What's Next?",
    text: `<p>As we enter a new decade, Jordan continues to invest in water development projects across the country and establish more efficient processes to ensure that all Jordanians have clean water when they open the tap at home.
    </p><p>Water is a limited resource, and what each of us does makes a difference. As we learn the value of clean, safe water and how scarce it truly is, we can become more aware of our consumption and take steps to protect it in our daily lives. Small actions today can have a big impact tomorrow.
    </p>`,
  },
  ar: {
    title: 'ماذا بعد؟',
    text:
      '<p>ونحن ندخل عَقداً جديداً؛ يستمر الأردن بالاستثمار في مشاريع تطوير المياه وتأسيس إجراءاتٍ أكثر كفاءة لضمان أن جميع الأردنيين لديهم الماء عند فتحهم الصنبور في منازلهم.</p><p>الماء مورد محدود، وما يفعله كل منا يحدث فرقا. بينما نتعلم قيمة المياه النظيفة والآمنة ومدى ندرتها، يمكننا أن نكون أكثر وعياً باستهلاكنا وأن نتّخذ خطوات لحمايتها في حياتنا اليومية. يمكن أن يكون للأعمال الصغيرة اليوم تأثير كبير غدًا.</p>',
  },
};

const Outro = () => {
  const {
    state: {lang},
  } = useStore();
  return (
    <OutroWrapper>
      <div className='content'>
        <h1>{content[lang].title}</h1>
        <section className='text'>
          <div dangerouslySetInnerHTML={createMarkup(content[lang].text)} />
          <div className='links'>
            <Link to='/map'>
              {lang === 'en' ? 'Explore Map' : 'إكتشف الخريطة'}
            </Link>
            <Link to='/timeline'>
              {lang === 'en' ? 'Explore Timeline' : 'إكتشف الجدول الزمني'}
            </Link>
          </div>
        </section>
      </div>
    </OutroWrapper>
  );
};

export default Outro;
